import "./index.css";
import { useEffect } from "react";
import { Outlet, useLocation } from "react-router-dom";
import { ConsentBanner } from "./components/ConsentBanner";
import { initAnalytics } from "./analytics";
import { startActiveTimeTracking } from "./analytics/activity";
import DomainRouter from "./DomainRouter";
import React from "react";
// QueryClientProvider is provided at the root in src/main.tsx
import { ThemeProvider } from "./hooks/useTheme";
import { ModalProvider } from "./v32/components/ModalProvider";
import { Toaster } from "./v32/components/ui/sonner";
import { AppShell } from "./navigation/AppShell";

// Query client is initialized in src/main.tsx via Wasp helpers

// AuthRedirectHandler and PostLoginSync moved to routes/AuthLayout.tsx

export default function App() {
  const { pathname } = useLocation();
  // Match DomainRouter's public paths to avoid showing app chrome on auth/public views
  const isPublicPath = (p: string) =>
    p === "/login" ||
    p === "/signup" ||
    p === "/logout" ||
    p === "/onboarding" ||
    p === "/verify-email" ||
    p === "/password-reset" ||
    p === "/forgot-password" ||
    p === "/reset-password" ||
    p.startsWith("/public") ||
    p.startsWith("/r/") ||
    p.startsWith("/p/") ||
    p.startsWith("/embed/");
  useEffect(() => {
    // Runtime sanity check for React instances


    // Safe analytics init; keep active time tracking off for now
    try {
      initAnalytics();
    } catch (e) {
      console.warn("Analytics init failed", e);
    }
    // startActiveTimeTracking();
  }, []);

  // Enhanced error debugging for development
  useEffect(() => {
    if (import.meta.env.DEV) {
      // Global error handler for script import failures
      window.addEventListener("error", (e) => {
        // @ts-ignore: some props are non-standard but present in browsers
        console.error(
          "[GlobalError]",
          e.message,
          e.filename,
          e.lineno,
          e.colno,
          e.error?.stack,
        );
      });

      // Unhandled promise rejections
      window.addEventListener("unhandledrejection", (e) => {
        console.error("[UnhandledRejection]", e.reason);
      });
    }
  }, []);

  // Domain-based routing with thin shell: providers + routed content
  const RoutedContent = (
    <>
      <ConsentBanner />
      <Outlet />
      <Toaster position="top-right" richColors closeButton />
    </>
  );

  return (
    <ThemeProvider>
      <ModalProvider>
        <DomainRouter>
          {isPublicPath(pathname) ? (
            RoutedContent
          ) : (
            <AppShell>{RoutedContent}</AppShell>
          )}
        </DomainRouter>
      </ModalProvider>
    </ThemeProvider>
  );
}
